module.exports = __webpack_public_path__ + "assets/img/Type E (18).d447d0a9.jpg";